import { render, staticRenderFns } from "./ItemImageCarousel.vue?vue&type=template&id=21a04e55"
import script from "./ItemImageCarousel.vue?vue&type=script&lang=js"
export * from "./ItemImageCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports